import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// Stimulus
window.Stimulus = Application.start();
const context = require.context('./controllers', true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

// Tippy
tippy('[data-tippy-content]', {
	placement: 'top-end',
});

// Lightbox
require('fslightbox');
